<template>
  <div class="news-list-container">
    <div v-if="showUnread" @click="onShowNewMessage" class="row unread-message">
      <img src="../../assets/img/arrow-up.svg" class="icon" alt="">
      <div class="unread-count">{{latestNewsData.length}}条新闻</div>
    </div>
    <div class="title" v-if="companyName">舆情新闻列表</div>
    <div class="row news-list-tab-input" v-if="companyName">
      <!-- <div class="news-list-tab" v-if="!companyName">
        <sn-tabs :tabs="dateRangeTabs" @change="onDateRangeTabChange"></sn-tabs>
      </div>-->
      <div class="news-list-tab">
        <sn-tabs :tabs="typeTabs" @change="onTypeTabChange"></sn-tabs>
      </div>
      <!-- <div class="news-list-input">
        <input ref="input" type="text" :placeholder="placeholder" v-model.trim="searchText">
      </div>-->
    </div>
    <div class="row news-type-tab">
      <el-button
        class="news-type-tab-btn"
        :class="{'news-type-tab-active': item === market}"
        v-for="(item, index) in dateRangeTabs"
        :key="index"
        @click="onTabClick(item)"
      >{{item}}</el-button>
    </div>
    <CriteriaSearchArea v-if="filterTag" :filterTag="filterTag" @checkedArr="checkedArr" />
    <div class="row news-list-source-filter">
      <div class="total-count">共有{{totalCount}}条相关新闻</div>
      <div class="news-list-source-filter-right">
        <SnDatePicker @timeChange="timeChange"></SnDatePicker>
        <el-select class="select set-vertical-align" v-model="source" @change="onSourceChange" placeholder="全部来源">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>  
        <el-select class="select set-vertical-align" v-model="inewsImportanceLever" @change="onInewsImportanceLeverChange" placeholder="重要程度">
          <el-option
            v-for="item in inewsImportanceLeverOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-tooltip 
          class="item" 
          effect="dark" 
          :content="cluesTip" 
          :visible-arrow="false"
          :enterable="false"
          popper-class="clues-tip"
          placement="bottom-start"
        >
          <el-button v-if="showClues" @click="showClues = false" class="clues-show-btn set-vertical-align"><img :src="require('../../assets/img/clues.svg')" class="icon" alt=""></el-button>
          <el-button v-else @click="showClues = true" class="clues-show-btn set-vertical-align"><img :src="require('../../assets/img/clues.svg')" class="icon" alt=""></el-button>
        </el-tooltip>
      </div>
    </div>
    <div v-loading="isLoading">
      <div>
        <div
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
        >
          <news-list-item
            v-for="(item, index) in resultData"
            :key="index"
            :data="item"
            :showClues="showClues"
          ></news-list-item>
        </div>
      </div>
      <div class="loading" v-if="itemData.length && resultData.length && totalCount>pageSize">
        <div class="loading-word">加载中...</div>
      </div>
      <div class="loading" v-if="!itemData.length && resultData.length || (totalCount>0 && totalCount<=pageSize)">
        <div class="loading-word">没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
// import NewsListFilter from '@/components/news-monitor/NewsListFilterV3';
// import NewsListFilterPanel from '@/components/news-monitor/NewsListFilterPanelV3';
import CriteriaSearchArea from '@/components/news-monitor/CriteriaSearchArea';
import NewsListItem from '@/components/news-monitor/NewsListItemV2';
import SnTabs from '@/components/common/SnTabsV2';
import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  name: 'news-list',
  props: {
    searchText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inewsImportanceLever: '重要程度',
      inewsImportanceLeverData: [],
      inewsImportanceLeverOptions: [
        {
          value: '不限',
          label: '不限'
        },
        {
          value: '重要新闻',
          label: '重要新闻'
        },
        {
          value: '次要新闻',
          label: '次要新闻'
        },
        {
          value: '普通新闻',
          label: '普通新闻'
        }
      ],
      scrollTopNewsTimer: null,
      latestNewsData: [],
      showUnread: false,
      newsListDoc: null,
      type: 'company',
      resultData: [],
      busy: false,
      timer: null,
      filterTag: null,
      showClues: true,
      isLoading: false,
      placeholder: '搜索标签',
      typeTabs: ['公司舆情', '周边舆情'],
      dateRangeTabs: ['全部', 'A股', '港股', '科创', '新三板', '债市', '美股'],
      totalCount: 0,
      option: '全部来源',
      options: [
        {
          value: '全部来源',
          label: '全部来源'
        },
        {
          value: '官媒',
          label: '官媒'
        },
        {
          value: '公众号',
          label: '公众号'
        }
      ],
      itemData: [],
      pageSize: 20,
      market: '全部',
      positive: [],
      negative: [],
      negativeTag: [],
      source: '全部来源',
      positiveArr: [],
      negativeArr: [],
      changePositive: [],
      changeNegative: [],
      companyName: '',
      typeTag: 'all',
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      flag: false,
      positivearr: [],
      negativearr: [],
      latestNewsTimer: null,
      date: []
    };
  },
  computed: {
    cluesTip() {
      return this.showClues ? '隐藏线索' : '显示线索';
    }
  },
  methods: {
    onInewsImportanceLeverChange(res) {
      this.getLatestNewsSetInterval(false);
      switch (res) {
        case '不限':
          this.inewsImportanceLever = '重要程度';
          this.inewsImportanceLeverData = [];
          break;
        case '重要新闻':
          this.inewsImportanceLeverData = ['高'];
          break;
        case '次要新闻':
          this.inewsImportanceLeverData = ['中'];
          break;
        case '普通新闻':
          this.inewsImportanceLeverData = ['低'];
          break;
        default:
          break;
      }
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    timeChange(date) {
      this.getLatestNewsSetInterval(false);
      this.date = date || [];
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onSourceChange(res) {
      this.getLatestNewsSetInterval(false);
      this.source = res;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    checkedArr({ negative, positive }) {
      this.getLatestNewsSetInterval(false);
      this.positive = positive;
      this.negative = negative;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onTabClick(res) {
      this.getLatestNewsSetInterval(false);
      this.market = res;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    onTypeTabChange(res) {
      this.getLatestNewsSetInterval(false);
      if (res.item === '公司舆情') {
        this.type = 'company';
      } else if (res.item === '周边舆情') {
        this.type = 'perimeter';
      }
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstNewsListV2();
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.itemData.length) {
        this.timer = setTimeout(() => {
          this.getNewsListV2();
        }, 500);
      }
    },
    positiveCheckedTag(res) {
      if (res.type) {
        this.positiveArr = [
          {
            label: '全部正面',
            type: 'positive'
          }
        ];
      } else {
        this.positiveArr = res.checkedObjList;
      }
      this.positive = res.checkedArrayList;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      // this.latestDateNum = -1;
      this.getNewsListV2();
    },
    negativeCheckedTag(res) {
      if (res.type) {
        this.negativeArr = [
          {
            label: '全部负面',
            type: 'negative'
          }
        ];
      } else {
        this.negativeArr = res.checkedObjList;
      }
      this.negative = res.checkedArrayList;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      // this.latestDateNum = -1;
      this.getNewsListV2();
    },
    onDateRangeTabChange(res) {
      if (res.item === '科创') {
        this.market = '科创板';
      } else {
        this.market = res.item;
      }
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      // this.latestDateNum = -1;
      this.getNewsListV2();
    },
    getNewsListTagV2() {
      if (this.companyName) {
        this.typeTag = 'company';
      }
      QuestionQuery.getNewsListTagV2(this.typeTag, this.companyName).then(res => {
        // eslint-disable-next-line
        res.negative &&
          res.negative.forEach(v => {
            v.checkAll = false;
            if (v.options) {
              v.options.forEach(item => (item.checked = false));
            }
          });
        // eslint-disable-next-line
        res.positive &&
          res.positive.forEach(v => {
            v.checkAll = false;
            if (v.options) {
              v.options.forEach(item => (item.checked = false));
            }
          });
        this.filterTag = res;
      });
    },
    getLatestNewsListV2() {
      let params;
      if (this.companyName) {
        params = {
          companies: [this.companyName],
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: 15,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: -1,
          type: this.type,
          company_importance_level: this.inewsImportanceLeverData.toString(),
          earliestDateNum: -1,
          latestDateNum: this.latestDateNum,
          date: this.date
        };
      } else {
        params = {
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: this.pageSize,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: -1,
          news_importance_level: this.inewsImportanceLeverData.toString(),
          earliestDateNum: -1,
          latestDateNum: this.latestDateNum,
          date: this.date
        };
      }
      QuestionQuery.getNewsListV2(params).then(
        res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.newsListDoc.scrollTop >= 0 && this.newsListDoc.scrollTop <= 500) {
              this.showUnread = false;
              this.newsListDoc.scrollTop = 0;
              this.resultData.unshift(...res.result);
            } else {
              this.showUnread = true;
              this.latestNewsData = this.latestNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestNewsSetInterval(false);
        }
      );
    },
    onShowNewMessage() {
      this.showUnread = false;
      if (this.latestNewsData.length >= 100) {
        this.resultData.unshift(...this.latestNewsData);
        this.latestNewsData = [];
        this.newsListDoc.scrollTop = 0;
      } else {
        this.scrollTopNewsTimer = setInterval(() => {
          if (this.newsListDoc.scrollTop) {
            this.newsListDoc.scrollTop = this.newsListDoc.scrollTop - 200;
          } else if (!this.newsListDoc.scrollTop || this.newsListDoc.scrollTop < 0) {
            clearInterval(this.scrollTopNewsTimer);
          }
        }, 50);
      }
    },
    getFirstNewsListV2() {
      let params;
      if (this.companyName) {
        params = {
          companies: [this.companyName],
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: this.pageSize,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: this.earliestNewsId,
          earliestDateNum: this.earliestDateNum,
          latestDateNum: -1,
          company_importance_level: this.inewsImportanceLeverData.toString(),
          type: this.type,
          date: this.date
        };
      } else {
        params = {
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: this.pageSize,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: this.earliestNewsId,
          earliestDateNum: this.earliestDateNum,
          news_importance_level: this.inewsImportanceLeverData.toString(),
          date: this.date,
          latestDateNum: -1
        };
      }
      this.isLoading = true;
      QuestionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.totalCount = res.totalCount;
        if (this.itemData.length) {
          this.latestDateNum = res.result[0].dateNum;
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
        this.getLatestNewsSetInterval(true);
      });
    },
    getLatestNewsSetInterval(start) {
      if (this.latestNewsTimer) {
        clearTimeout(this.latestNewsTimer);
      }
      if (start) {
        this.latestNewsTimer = setTimeout(() => {
          this.getLatestNewsListV2();
          this.getLatestNewsSetInterval(start);
        }, 1000 * 20);
      }
    },
    getNewsListV2() {
      let params;
      if (this.companyName) {
        params = {
          companies: [this.companyName],
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: this.pageSize,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: this.earliestNewsId,
          earliestDateNum: this.earliestDateNum,
          latestDateNum: -1,
          company_importance_level: this.inewsImportanceLeverData.toString(),
          type: this.type,
          date: this.date
        };
      } else {
        params = {
          sourceGenre: this.source === '公众号' ? '微信' : this.source,
          pageSize: this.pageSize,
          market: this.market === '科创' ? '科创板' : this.market,
          positive: this.positive,
          negative: this.negative,
          earliestNewsId: this.earliestNewsId,
          earliestDateNum: this.earliestDateNum,
          latestDateNum: -1,
          news_importance_level: this.inewsImportanceLeverData.toString(),
          date: this.date
        };
      }
      this.isLoading = true;
      QuestionQuery.getNewsListV2(params).then(res => {
        this.isLoading = false;
        this.itemData = res.result;
        this.totalCount = res.totalCount;
        this.busy = false;
        if (this.itemData.length) {
          this.earliestNewsId = this.itemData[this.itemData.length - 1].newsId;
          this.earliestDateNum = this.itemData[this.itemData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.itemData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    }
  },
  watch: {
    searchText(val) {
      this.companyName = val;
      this.itemData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      // this.latestDateNum = -1;
      this.positive = [];
      this.negative = [];
      this.positiveArr = [];
      this.negativeArr = [];
      this.changePositive = [];
      this.changeNegative = [];
      this.filterTag = null;
      this.getNewsListV2();
      this.getNewsListTagV2();
    }
  },
  mounted() {
    this.newsListDoc = document.documentElement;
    this.companyName = this.searchText;
    if (!this.$route.query.type) {
      this.getFirstNewsListV2();
      this.getNewsListTagV2();
    }
  },
  components: {
    // NewsListFilter,
    // NewsListFilterPanel,
    // NoData,
    // NewsListFilterPanel,
    // SimilarityNewsListItem
    CriteriaSearchArea,
    NewsListItem,
    SnTabs,
    SnDatePicker
  },
  beforeDestroy() {
    this.getLatestNewsSetInterval(false);
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.news-list-container {
  padding: 16px 24px;
  background-color: #ffffff;
  .unread-message {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 12px;
    height: 17px;
    background-color: #636772;
    border-radius: 2px;
    z-index: 1;
    cursor: pointer;
    .unread-count {
      margin-right: 4px;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .news-type-tab {
    height: 26px;
    .news-type-tab-btn {
      height: 26px;
      // width: 52px;
      margin-left: 0;
      margin-right: 6px;
      padding: 0 8px;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #747990;
      background-color: #f7f8fc;
      font-weight: 400;
      &:hover {
        color: #747990;
        background-color: #eaebef;
      }
      &:focus {
        color: #747990;
        background-color: #eaebef;
      }
      &:active {
        color: #747990;
        background-color: #eaebef;
      }
    }
    .news-type-tab-active {
      color: #ffffff;
      background-color: #45a8cc;
      font-weight: 400;
      &:hover {
        color: #ffffff;
        background-color: #3e97b8;
      }
      &:focus {
        color: #ffffff;
        background-color: #3e97b8;
      }
      &:active {
        color: #ffffff;
        background-color: #3e97b8;
      }
    }
  }
  .title {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 20px;
    color: white;
  }
  .news-list-tab-input {
    justify-content: space-between;
    .news-list-input {
      input {
        width: 160px;
        height: 26px;
        padding: 0 12px;
        color: #ffffff !important;
        font-size: 14px;
        background-color: rgba(19, 18, 21, 0.4);
        border-radius: 4px;
        border: solid 2px rgba(255, 255, 255, 0.2);
        outline: none;

        // &:hover {
        //   border: solid 2px #423f43;
        // }

        &:focus {
          border: solid 2px #5f5d60;
        }
      }
      input[placeholder] {
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
  .filter-tag {
    margin: 16px 0 0 0;
    width: 100%;
    // min-height: 96px;
    background-color: #f7f7fa;
  }
  .news-list-source-filter {
    justify-content: space-between;
    margin-top: 24px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #f7f7fa;
    border-bottom: 1px solid #f7f7fa;
    .total-count {
      color: #747990;
      font-size: 12px;
    }
    .news-list-source-filter-right {
      .clues-show-btn {
        margin-left: 10px;
        height: 26px;
        width: 40px;
        padding: 5px 8px;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        font-weight: 400;
        color: #464d6c;
        background-color: #f7f8fc;
        &:hover {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:focus {
          color: #464d6c;
          background-color: #eaebef;
        }
        &:active {
          color: #464d6c;
          background-color: #eaebef;
        }
      }
      .select {
        margin-left: 10px;
        width: 100px;
      }
    }
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464d6c;
  background-color: #f7f8fc !important;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
.pager {
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  & /deep/ {
    .el-pagination {
      .el-pager li {
        margin: 0 0.125rem;
        background: none;
        border-radius: 0;
        color: #b3b2b3;
        font-family: 'DIN-Regular';
        min-width: 32px;
        height: 32px;
        line-height: 32px;

        &.active {
          color: #fff;
          font-family: 'DIN-Bold';
        }

        &:hover {
          background-color: #333137;
          border-radius: 54px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        border: 0.0625rem solid #c2c2c2;
        &:focus {
          border-radius: 0;
          border: 0.0625rem solid #c2c2c2;
        }
      }
      .btn-prev,
      .btn-next {
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
        .el-icon-arrow-right:before {
          color: #fff;
        }
        &:hover {
          background-color: #333333;
          border-radius: 54px;
          .el-icon-arrow-left:before {
            color: #e8e8e8;
          }
          .el-icon-arrow-right:before {
            color: #e8e8e8;
          }
        }
      }
      .btn-prev[class='btn-prev disabled'] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
      }
      .btn-next[class='btn-next disabled'] {
        background: none;
        border-radius: 54px;
        .el-icon-arrow-right:before {
          color: #fff;
        }
      }
      button {
        padding: 0;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.is-dark.clues-tip {
  padding: 4px 8px;
  border-radius: 2px;
  color: #ffffff;
  font-size: 12px;
  background-color: #3d414f;
}
</style>
